import { Button, Intent } from '@blueprintjs/core';

interface ResetDataButtonProps {
  handleReset: () => void;
}
const ResetDataButton = ({ handleReset }: ResetDataButtonProps) => {
  return (
    <Button fill icon={'reset'} intent={Intent.PRIMARY} onClick={handleReset}>
      Limpar dados
    </Button>
  );
};

export default ResetDataButton;
